import { z } from 'zod';
import { createPartialStrictObjectSchemaWithAtLeastOneProperty } from './PartialStrictObjectSchema.ts';
import { singleDieSchema } from './SharedZodSchemas.ts';
import { validateState } from './ValidateState.ts';
export const diceStateSchema = z.object({
    diceThrown: z.boolean(),
    dice1: singleDieSchema,
    dice2: singleDieSchema
}).strict();
export function validateDiceState(data) {
    return validateState(diceStateSchema, data);
}
export const diceStatePartialSchema = createPartialStrictObjectSchemaWithAtLeastOneProperty(diceStateSchema);
